import { render } from "./package.vue?vue&type=template&id=1b9a91d2&scoped=true"
import script from "./package.vue?vue&type=script&lang=js"
export * from "./package.vue?vue&type=script&lang=js"

import "./package.vue?vue&type=style&index=0&id=1b9a91d2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b9a91d2"

export default script